// Libs
import classNames from 'classnames/bind';
import { ResponsivePie } from '@nivo/pie';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IBasePieData } from '~/utils/interface/common';
// Styles
import styles from './BasePieChart.module.scss';

type Props = {
  data: IBasePieData[];
};

const cx = classNames.bind(styles);

const BasePieChart = (props: Props) => {
  //#region Destructuring Props
  const { data } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <div className={cx('pieWrapper')}>
      <ResponsivePie
        data={data}
        innerRadius={0}
        padAngle={2}
        colors={{ datum: 'data.color' }}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
        enableArcLinkLabels={false}
        arcLabelsTextColor='#000'
        arcLabel={(d) => (Number(d.value) > 0 ? `${d.label}` : EMPTY_STRING)}
        theme={{
          labels: {
            text: {
              fontSize: 12,
              fontWeight: 400,
            },
          },
        }}
      />
    </div>
  );
};

export default BasePieChart;
